<template>
  <div>
    <a-alert
      message="重置密码"
      description="成功"
      type="info"
      show-icon
      class="result-alert"
    />

    <a-button type="primary" size="large" block @click="$emit('go-login')">
      前往登录
    </a-button>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.result-alert {
  margin-bottom: 30px;
}
</style>
